const viewTypes = {
	MarkerAppointmentManagement : 'MarkerAppointmentManagement',
	ScriptDates : 'ScriptDates'
};

export default viewTypes;